import { PurchaseFileRepository } from '@domain/purchase-file/repositories/purchase-file.repository';
import { PurchaseFileRepositoryService } from '../repositories/purchase-file.service';

export const PurchaseFileProvider = [
  {
    provide: PurchaseFileRepository,
    useClass: PurchaseFileRepositoryService,
  },
];
